export const COLOR_MAPPING = {
  green: "#82ca9d",
  purple: "#8884d8",
  yellow: "#ffc658",
  orange: "#ff7300",
  blue: "#8dd1e1",
  red: "#ff4d4f",
};

export const COLORS = [
  COLOR_MAPPING.blue,
  COLOR_MAPPING.green,
  COLOR_MAPPING.yellow,
  COLOR_MAPPING.orange,
  COLOR_MAPPING.purple,
];
